
interface ActivityStatsProps {
  totalActivities: number;
  publishedActivities: number;
  categoriesCount: number;
  loading?: boolean;
}

export const ActivityStats = ({ 
  totalActivities, 
  publishedActivities, 
  categoriesCount, 
  loading = false 
}: ActivityStatsProps) => {
  if (loading) {
    return (
      <section className="py-12 bg-white/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="text-center p-6 bg-white/60 rounded-2xl shadow-lg animate-pulse">
                <div className="h-8 bg-gray-200 rounded mb-2"></div>
                <div className="h-4 bg-gray-200 rounded"></div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 bg-white/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="text-center p-6 bg-white/60 rounded-2xl shadow-lg">
            <div className="text-3xl font-bold text-teedee-blue mb-2">{publishedActivities}+</div>
            <div className="text-sm text-gray-600">Free Activities</div>
          </div>
          <div className="text-center p-6 bg-white/60 rounded-2xl shadow-lg">
            <div className="text-3xl font-bold text-bobo-green mb-2">Ages 3-12</div>
            <div className="text-sm text-gray-600">All Ages Welcome</div>
          </div>
          <div className="text-center p-6 bg-white/60 rounded-2xl shadow-lg">
            <div className="text-3xl font-bold text-brand-purple mb-2">100%</div>
            <div className="text-sm text-gray-600">Educational Fun</div>
          </div>
          <div className="text-center p-6 bg-white/60 rounded-2xl shadow-lg">
            <div className="text-3xl font-bold text-golden-orange mb-2">🇰🇾</div>
            <div className="text-sm text-gray-600">Cayman Culture</div>
          </div>
        </div>
      </div>
    </section>
  );
};
